<template>
  <div class="attachments-control datepicker_top">
    <Upload
      ref="upload"
      :modelId="referral.id"
      :attachments="referral.attachments"
      :disabled="disabled"
      label=""
      :dropEnabled="false"
      :formClass="'upload-control dashed-border d-flex align-items-center flex-column'"
      data-v-tour="uploads"
      @uploaded="($event) => $emit('uploaded', $event)"
    >
      <template v-slot:uploadItem="{ file, i }">
        <li v-if="!file.created_by && (file.active || file.progress !== '0.00')">
          <a href="javascript:;" target="_blank" class="d-flex align-items-center img-link">
            <font-awesome-icon
              :icon="'spinner-third'"
              style="font-size: 30px; width: 30px"
              class="mr-3"
              spin
            ></font-awesome-icon>
          </a>
          <div class="file-name mt-2" style="word-break: break-all">{{ file.name }}</div>

          <span v-if="file.success">success</span>
          <span v-if="file.error" class="text-danger">failed </span>
          <!--{{ (file.response && file.response.url) || file.error }}</span> -->
          <div v-else class="progress mt-1">
            <div
              :class="{
                'progress-bar': true,
                'bg-primary': file.success,
                'bg-danger': file.error,
                'progress-bar-animated': file.active,
              }"
              role="progressbar"
              :style="{ width: file.progress + '%' }"
            >
              {{ file.progress + '%' }}
            </div>
          </div>
        </li>
        <li v-else>
          <file
            :key="file.id"
            :file="file"
            :title="file.custom_name || file.name"
            :disableLink="false"
            :showDelete="true"
            @imgClick="(e) => imageClicked(e, i)"
          >
            <div slot="afterIcon" class="file-name mt-2" style="word-break: break-all">
              {{ file.custom_name || file.name }}
              <!-- <small class="d-block" v-if="file.updated_at">
                                {{
                            moment(file.item_date || file.updated_at).fromNow()
                          }}</small> -->
            </div>
            <div slot="afterDetails"></div>
          </file>
        </li>
      </template>
    </Upload>
    <Lightbox ref="lightBox" v-if="referral.attachments" :images="referral.attachments">
      <template v-slot:preview> </template>
      <template v-slot:info="{ file }">
        <div class="d-flex flex-column" @click.stop="isFileMoreDetailsVisible = !isFileMoreDetailsVisible">
          <span class="text-overflow" :title="file.custom_name || file.name">{{ file.custom_name || file.name }}</span
          ><br />
          <div class="row">
            <div class="col">
              <small class="text-muted font-weight-bold">{{ file.size | formatSize }}</small>
              <a :href="$helpers.cdnUrl(file.url) + '?download=true'" target="_blank" class="" @click.stop>
                <font-awesome-icon :icon="['far', 'download']" class="ml-2" />
              </a>
            </div>
            <div class="col text-right">
              <small
                ><a href="javascript:void(0)" @click.stop="isFileMoreDetailsVisible = !isFileMoreDetailsVisible"
                  >{{ isFileMoreDetailsVisible ? 'Less' : 'More' }} details</a
                ></small
              >
            </div>
          </div>
        </div>
        <template v-if="isFileMoreDetailsVisible">
          <div style="font-size: 0.8rem" @click.stop>
            <div class="row mt-3">
              <div class="col-4 text-right text-muted">Tags</div>
              <div class="col">
                <span v-if="file.document_type === 1" class="badge badge-primary">X-ray</span
                ><span v-else-if="file.document_type === 2" class="badge badge-primary">Report</span
                ><span v-else class="text-muted">None</span>
              </div>
            </div>
            <div class="row">
              <div class="col-4 text-right text-muted">Created</div>
              <div class="col" :class="{ 'text-muted': !file.item_date }">
                {{ file.item_date ? moment(file.item_date).format('lll') : 'Unknown' }}
              </div>
            </div>
            <div class="row">
              <div class="col-4 text-right text-muted">Uploaded</div>
              <div class="col">{{ moment(file.created_at).format('lll') }}</div>
            </div>
            <div class="row">
              <div class="col-4 text-right text-muted">Modified</div>
              <div class="col">{{ moment(file.updated_at).format('lll') }}</div>
            </div>
            <div class="row" v-if="file.width">
              <div class="col-4 text-right text-muted">Dimensions</div>
              <div class="col">{{ file.width }}x{{ file.height }}</div>
            </div>
          </div>
        </template>
      </template>
    </Lightbox>
  </div>
</template>

<script>
import File from '@/components/files/File'
import Lightbox from '@/components/files/Lightbox.vue'
import Upload from '@/components/files/UploadGrid'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { File, Lightbox, Upload },
  props: {
    referralId: { required: true },
    showIndicator: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  created() {},
  computed: {
    ...mapGetters('referrals', ['all', 'get']),
    referral() {
      return this.get(this.referralId) || { id: -1, attachments: [] }
    },
  },
  data() {
    return {
      isFileMoreDetailsVisible: false,
    }
  },
  methods: {
    imageClicked(e, i) {
      e.preventDefault()
      e.stopPropagation()
      this.$refs.lightBox.show(i)
    },
  },
  destroyed() {},
}
</script>

<style lang="scss">
.attachments-control {
  .thumbnail-grid {
    // margin: 1em 0;
    padding: 0;
    list-style: none;
    display: grid;
    align-items: center;
    grid-gap: 1rem;
    gap: 1rem;
    grid-template-columns: repeat(1, minmax(0, 1fr));

    li {
      text-align: center;
      height: 200px;
      &:not(.browse-control) {
        border: 1px solid var(--border-color);
        border-radius: 5px;
      }
      a.img-link {
        min-height: 150px;
        display: flex !important;
        justify-content: center;
        align-items: center;
        background: #f8f9f9; // var(--light-color);
        border-bottom: 1px solid var(--border-color);
      }
      img {
        max-width: 100%;
        max-height: 150px;
      }
      .file-name {
        // min-height: 150px;
        // display: flex !important;
        justify-content: center;
        align-items: center;
        // height: 70px;
        font-size: 0.8rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 0.5rem;
        min-width: 0;
      }
      .upload-control {
        padding: 1rem !important;
        justify-content: center;
        height: 200px;

        a {
          min-height: auto;
        }
      }
    }
  }
}
@media (min-width: 576px) {
  .attachments-control .thumbnail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 768px) {
  .attachments-control .thumbnail-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
</style>